
import Color from 'color';

/**
 * 混合自定义颜色的算法
 * @param {*} mixinColor 
 * @param {*} alpha 
 * @returns 
 */
export function mixinFreeColor(mixinColor, alpha) {
    const bg = isDark(mixinColor) ? '#fff' : '#000';
    let colroBG = Color(bg).object();
    // let colorRGB = Color(mixinColor).rgb().array();
    let colorRGB = Color(mixinColor).object();
    if (!colorRGB) {
        return mixinColor;
    }

    let rColor = Number((1 - alpha) * colroBG.r + alpha * colorRGB.r).toFixed(0);
    let gColor = Number((1 - alpha) * colroBG.g + alpha * colorRGB.g).toFixed(0);
    let bColor = Number((1 - alpha) * colroBG.b + alpha * colorRGB.b).toFixed(0);

    let color = {
        r: rColor,
        g: gColor,
        b: bColor,
    };
    // console.log(Color, Color(color));
    return Color(color).hex();
}

// 是否属于偏向黑暗的
function isDark(contrastColor) {
    // from 1 (same color) to 21 (contrast b/w white and black)
    const contrastVal = Color(contrastColor).contrast(Color('#fff'));
    return contrastVal > 3;
}

/**
 * 获取对比度符合标准的字体颜色
 * @param {String} baseColor 
 * @returns 
 */
function getContrastFontColor(baseColor) {
    let color = isDark(baseColor) ? '#fff' : '#111';
    return color;
}
//  rgb 转 hsl
function rgbToHsl(r, g, b) {
    r /= 255, g /= 255, b /= 255;
    let max = Math.max(r, g, b), min = Math.min(r, g, b);
    let h, s, l = (max + min) / 2;
    if (max == min) {
        h = s = 0; // achromatic
    } else {
        let d = max - min;
        s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
        switch (max) {
            case r: h = (g - b) / d + (g < b ? 6 : 0); break;
            case g: h = (b - r) / d + 2; break;
            case b: h = (r - g) / d + 4; break;
        }
        h /= 6;
    }
    return { h, s, l };
}
// hsl 转 rgb 
function hslToRgb(h, s, l) {
    let r, g, b;
    if (s == 0) {
        r = g = b = l; // achromatic
    } else {
        let hue2rgb = function hue2rgb(p, q, t) {
            if (t < 0) {t += 1;}
            if (t > 1) {t -= 1;}
            if (t < 1 / 6) {return p + (q - p) * 6 * t;}
            if (t < 1 / 2) {return q;}
            if (t < 2 / 3) {return p + (q - p) * (2 / 3 - t) * 6;}
            return p;
        };
        let q = l < 0.5 ? l * (1 + s) : l + s - l * s;
        let p = 2 * l - q;
        r = hue2rgb(p, q, h + 1 / 3);
        g = hue2rgb(p, q, h);
        b = hue2rgb(p, q, h - 1 / 3);
    }
    return { r: Math.round(r * 255), g: Math.round(g * 255), b: Math.round(b * 255) };
}
function ColorLuminance(mixinColor) {
    if (!isDark(mixinColor)) {
        return getColorByLight(mixinColor, light => light > 0.2 ? light - 0.2 : 0);
    }
    return mixinColor;
}

// 通过对hsl的亮度调整获取色值
// lightFunc动态计算l值函数
// alpha
function getColorByLight(mixinColor, lightFunc, alpha = 1) {
    if (!lightFunc) { // 默认计算逻辑
        // L值大于50，值为50；小于等于50，值-10，直至0
        lightFunc = light => light > 0.5 ? 0.5 : Math.max(light - 10, 0);
    }
    const { r, g, b } = Color(mixinColor).object();
    let { h, s, l } = rgbToHsl(r, g, b);
    l = lightFunc(l);
    const { r: rColor, g: gColor, b: bColor } = hslToRgb(h, s, l);
    return Color({
        r: rColor,
        g: gColor,
        b: bColor,
        alpha
    }).toString();
}

export const getMixinVars = mixinColor => {
    return {
        // 工作桌面导航背景颜色
        '--workbench-nav-bg-color': mixinColor,
        // 工作桌面导航栏搜索框hover边框颜色
        '--workbench-search-app-hover-border-color': mixinFreeColor(mixinColor, 0.4),
        // 工作桌面导航栏搜索框hover背景色
        '--workbench-search-app-hover-bg-color': mixinFreeColor(mixinColor, 0.9),
        // 工作桌面导航栏搜索框默认边框颜色
        '--workbench-search-app-border-color': mixinFreeColor(mixinColor, 0.6),
        // 工作桌面导航栏搜索框默认背景色
        '--workbench-search-app-bg-color': mixinFreeColor(mixinColor, 0.9),
        // 工作桌面导航栏搜索框默认文字颜色
        '--workbench-search-app-input-color': getContrastFontColor(mixinFreeColor(mixinColor, 0.6)),
        // 工作桌面导航栏搜索框focus颜色
        '--workbench-search-app-focus-color': getContrastFontColor(mixinFreeColor(mixinColor, 0.6)),
        // 工作桌面导航栏应用菜单扇叶颜色
        '--workbench-nav-allapps-color': mixinFreeColor(mixinColor, 0.95),
        // 工作桌面导航栏应用菜单扇叶hover颜色
        '--workbench-nav-allapps-hover-color': mixinFreeColor(mixinColor, 0.8),
        // 面包屑文字颜色 
        '--workbench-nav-breadcrumb-color': getContrastFontColor(mixinColor),
        // 面包屑中间箭头颜色 
        '--workbench-nav-breadcrumb-color1': getContrastFontColor(mixinColor),
        // 面包屑hover底色
        '--workbench-nav-breadcrumb-hover-bg-color': mixinFreeColor(mixinColor, 0.6),
        // 面包屑当前节点文字颜色
        '--workbench-nav-breadcrumb-current-color': getContrastFontColor(mixinColor),
        // 导航栏图标颜色 集团切换
        '--workbench-nav-icon-color': getContrastFontColor(mixinColor),
        // 应用菜单 标题 颜色
        '--workbench-allapps-title-color': ColorLuminance(mixinColor),
        // 应用菜单 竖线颜色
        '--workbench-allapps-line-color': ColorLuminance(mixinColor),
        // 个人中心文字hover颜色
        '--workbench-user-info-hover': ColorLuminance(mixinColor),
        // 桌面配置顶部页签文字 底部横线 颜色
        '--workbench-desktop-setting-title-color': ColorLuminance(mixinColor),
        // 桌面配置 当前分组页面背景色
        '--workbench-home-current-tab-bg-color': ColorLuminance(mixinColor),
        // 桌面配置 浏览态 当前分组页签文字颜色
        '--workbench-home-tab-current-title-color': getContrastFontColor(mixinFreeColor(mixinColor, 0.8)),
        // 桌面配置 编辑态 当前分组页签文字颜色
        '--workbench-home-tab-editable-current-title-color': ColorLuminance(mixinColor),
        //搜索栏中主色调设为白色
        '--workbench-nav-search-color': getContrastFontColor(mixinColor),
        //搜索栏背景色
        '--workbench-nav-search-bg': 'rgba(255, 255, 255, 0.1)',
        //搜索栏边框颜色
        '--workbench-nav-border-color': 'rgba(255,255,255,0.2)',
        //搜索栏其他色边框聚焦颜色
        '--workbench-nav-border-color-focus': 'rgba(255,255,255,0.5)',
        //搜索栏边框hover颜色
        '--workbench-nav-border-color-hover': 'rgba(255,255,255,0.2)',
        // 导航栏工作台选中激活颜色
        '--workbench-nav-active': mixinFreeColor(mixinColor, 0.95),
        //搜索栏竖线透明度
        '--workbench-nav-search-shuxian-opacity': 0.2,
        //搜索栏select框背景色
        '--workbench-nav-select-bg-color': 'white',
        //搜索栏select框文字hover时的颜色
        '--workbench-nav-select-text-color': 'rgba(240, 240, 240)',
        //搜索框联想面板的字体颜色
        '--workbench-nav-search-more-color': '#2B2C42',
        //搜索框联想面板的分类标题颜色
        '--workbench-nav-search-title-color': '#2B2C42',
        //搜索框联想面板标题背景颜色
        '--workbench-nav-title-bg-color': '#F8F8F8',
        //搜索栏下拉框图标颜色
        '--workbench-nav-select-drop-color': getContrastFontColor(mixinColor),
        //搜索栏下拉选中字体颜色
        '--workbench-nav-select-drop-text-color': 'rgba(233,240,250)',
        //搜索栏暂无数据搜索图标颜色
        '--workbench-nav-search-icon-sousuo1-color': '#d1d1d1',
        //搜索栏横线颜色
        '--workbench-nav-search-hr-color': '#F0F0F0',
        //内部页签标签栏背景色
        '--workbench-tab-wrapper-bg': getColorByLight(mixinColor, () => 0.97),
        //内部页签选中字体颜色
        '--workbench-tab-active-color': getColorByLight(mixinColor),
        //内部页签标签栏背景下划线
        '--workbench-tab-bottom-color': getColorByLight(mixinColor, null, 0.22),
        // 面包屑首页下拉图标颜色
        '--workbench-breadcrumb-home-icon-c': getContrastFontColor(mixinColor),
        // 面包屑首页下拉图标透明度
        '--workbench-breadcrumb-home-icon-o': isDark(mixinColor) ? 0.9 : 0.6,
        // 面包屑首页下拉图标边框透明度
        '--workbench-breadcrumb-home-icon-bo': isDark(mixinColor) ? 0.6 : 0.2,
        // 基于主色hsl格式，l值为93
        '--workbench-color-primary-l93': getColorByLight(mixinColor, () => 0.93),
        '--workbench-color-primary-l95': getColorByLight(mixinColor, () => 0.95),
    };
};